import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import isEmpty from 'lodash/isEmpty';
import { styled } from '@mui/system';
import MuiGrid from '@mui/material/Grid';
import MuiInputLabel from '@mui/material/InputLabel';
import Icon from '@cpg-its/ads.common.icon';
import Tooltip from '@cpg-its/ads.common.tooltip';
import Typography from '@cpg-its/ads.common.typography';
import { black, blue, red } from '@cpg-its/ads.constants.colors';
const StyledInputLabel = styled(MuiInputLabel)({
    marginBottom: '4px',
    '& .MuiInputLabel-asterisk': {
        color: red,
        marginLeft: '0.25rem',
    },
});
const IconWrapper = styled(MuiGrid)({
    display: 'inline',
    position: 'relative',
    marginRight: '0.25rem',
    top: '2px',
});
const SubLabelWrapper = styled(MuiGrid)({
    display: 'inline-flex',
    marginLeft: '0.5rem',
});
const TooltipWrapper = styled(MuiGrid)({
    float: 'right',
});
export const InputLabelComponent = ({ color = '', label = '', published = false, required = false, subLabel = '', testId = undefined, tooltip = {}, }) => {
    const publishedIcon = published ? (_jsx(IconWrapper, { children: _jsx(Icon, { color: blue, icon: "published", size: "small" }) })) : null;
    const renderSubLabel = subLabel ? (_jsx(SubLabelWrapper, { children: typeof subLabel === 'string' ? (_jsx(Typography, { component: "span", text: subLabel })) : subLabel })) : null;
    const renderTooltip = (() => {
        if (!isEmpty(tooltip)) {
            const { iconColor } = tooltip;
            return (_jsx(TooltipWrapper, { children: _jsx(Tooltip, { iconColor: iconColor || blue, ...tooltip }) }));
        }
        return null;
    })();
    return (_jsxs(StyledInputLabel, { "data-testid": testId, disableAnimation: true, required: required, children: [publishedIcon, _jsx(Typography, { extraBold: true, component: "span", text: label, color: color || black }), renderSubLabel, renderTooltip] }));
};
export default InputLabelComponent;
//# sourceMappingURL=input-label.js.map